import { render, staticRenderFns } from "./FormResultDataView.vue?vue&type=template&id=f48633d8&scoped=true"
import script from "./FormResultDataView.vue?vue&type=script&lang=js"
export * from "./FormResultDataView.vue?vue&type=script&lang=js"
import style0 from "./FormResultDataView.vue?vue&type=style&index=0&id=f48633d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f48633d8",
  null
  
)

export default component.exports